var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.494 13.254a.751.751 0 0 1 0 1.492l-.076.004H2.75a.75.75 0 0 1 0-1.5h10.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.105 1.833a1.99 1.99 0 0 1 2.814 2.812l-6.023 6.023c-.624.624-1.033 1.04-1.543 1.326-.286.16-.703.292-1.095.401-.413.115-.888.228-1.333.334a.75.75 0 0 1-.904-.903c.106-.446.22-.92.334-1.333.11-.393.241-.81.402-1.096.285-.51.702-.919 1.326-1.543zM5.143 8.915c-.681.681-.917.927-1.077 1.214-.062.11-.154.364-.265.765l-.02.075q.037-.01.075-.02c.401-.11.655-.203.766-.265.286-.16.532-.395 1.214-1.077l4.615-4.616-.692-.693zm6.714-6.022a.49.49 0 0 0-.691 0l-.346.346.692.691.345-.345a.49.49 0 0 0 0-.692",
    clipRule: "evenodd"
  })));
};
export default Svg16;